"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Method = exports.useMethods = exports.Payments = void 0;
var Payments_1 = require("./Payments");
Object.defineProperty(exports, "Payments", { enumerable: true, get: function () { return __importDefault(Payments_1).default; } });
var useMethods_1 = require("./useMethods");
Object.defineProperty(exports, "useMethods", { enumerable: true, get: function () { return useMethods_1.useMethods; } });
var Method_1 = require("./Method");
Object.defineProperty(exports, "Method", { enumerable: true, get: function () { return __importDefault(Method_1).default; } });
